import { eula_pt } from './eula_pt';

export const locale_pt = {
  ...eula_pt,
  AddNew: 'Adicionar novo',
  SearchText: 'Inserir texto de pesquisa...',
  ClearFilter: 'Limpar filtro',
  Cancel: 'Cancelar',
  OK: 'OK',
  Yes: 'Sim',
  No: 'Não',
  Description: 'Descrição',
  English: 'English',
  Spanish: 'Español',
  Portuguese: 'Português',
  Russian: 'русский',
  French: 'Français',
  MyProfile: 'Meu perfil',
  CloseSession: 'Fechar sessão',
  Settings: 'Configurações',
  hrs: 'horas',
  EditTask: 'Editar tarefa',
  DeleteTaskQuestion: '¿Tem certeza de excluir esta tarefa?',
  Delete: 'Excluir',
  Reader: 'Leitor',
  Contributor: 'Contribuinte',
  Permissions: 'Permissões',
  Welcome: 'Bem-vindo',
  SelectEntity: 'Selecionar entidade',
  SetEntityTitle: 'Definir título da entidade',
  SetEntityType: 'Definir tipo de entidade',
  Add: 'Adicionar',
  SelectGroup: 'Selecionar grupo',
  SelectGroups: 'Selecionar grupos',
  SelectOrganization: 'Selecionar organização',
  SelectPermissions: 'Selecionar permissões',
  EntityType: 'Tipo de entidade',
  SelectRoles: 'Selecionar funções',
  SelectUser: 'Selecionar usuário',
  SelectUsers: 'Selecionar usuários',
  SelectVisibility: 'Selecionar visibilidade',

  Name: 'Nome',
  PleaseEnterName: 'Please enter a name',
  PleaseSelectASelector: 'Please select a selector',
  Save: 'Salvar',
  Reset: 'Redefinir',
  AddMembersToGroup: 'Adicionar membros ao grupo',
  AreYouSureRemove: 'Tem certeza que deseja remover',
  AreYouSureRemoveMember: 'Tem certeza que deseja remover {0} membro do grupo?',
  AreYouSureRemoveMembers: 'Tem certeza de que deseja remover {0} membros do grupo?',
  User: 'Usuário',
  Search: 'Pesquisar',
  AddMembers: 'Adicionar membros',
  Reload: 'Recarregar',
  AssignPermissionsToGroup: 'Atribuir permissões ao grupo',
  Entity: 'Entidade',
  Roles: 'Funções',
  Role: 'Função',
  AdminRoles: 'Funções de administrador',
  DefaultRoles: 'Papéis padrão',
  PermissionsAssigned: 'Permissões atribuídas',
  SearchEntity: 'Pesquisar Entidade',
  AssignNewRolesToGroup: 'Atribuir novas funções ao grupo',
  AreYouSureWantToUnassignRole: 'Tem certeza que deseja cancelar a atribuição de {0} função',
  AreYouSureWantToUnassignRoles: 'Tem certeza de que deseja cancelar a atribuição de {0} funções',
  AssignedRoles: 'Funções atribuídas',
  AssignRoles: 'Atribuir funções',
  GroupParam: 'Grupo {0}',
  Members: 'Membros',
  Groups: 'Grupos',
  NewGroup: 'Novo Grupo',
  IdentityAdministration: 'Administração de Identidade',
  OrganizationsManagement: 'Gestão de Organizaçõe',
  UsersManagement: 'Gerenciamento de usuários',
  RolesManagement: 'Gerenciamento de Funções',
  AdminRolesManagement: 'Gerenciamento de funções administrativas',
  GroupsManagement: 'Gestão de Grupos',
  PermissionsManagement: 'Gerenciamento de Permissões',
  RoleAssignmentsManagement: 'Gerenciamento de Atribuições de Função',
  DefaultRolesManagement: 'Gerenciamento de funções padrão',
  AuditLogs: 'Logs de Auditoria',
  Organizations: 'Organizações',
  Users: 'Usuários',
  Assignments: 'Atribuições',
  Logout: 'Sair',
  OrganizationDatabaseHasBeenCreated: 'O banco de dados da organização foi criado',
  OrganizationHasBeenBlocked: 'A organização foi bloqueada',
  OrganizationHasBeenUnblocked: 'A organização foi desbloqueada',
  EditPartnerOrganization: 'Editar organização parceira',
  SelectOrRemovePartnerOrganizationMessage: 'Selecione uma nova organização parceira para {0}',
  PleaseSelectAPartnerOrganization: 'Por favor, selecione uma organização parceira',
  Warning: 'Aviso',
  TestingEndDateAutomaticallyChangedWarning:
    'A data de término do período de testes da organização parceira selecionada é anterior à data de término do período de testes atualmente selecionada para esta organização. A data de término do período de testes foi atualizada automaticamente para corresponder à data de término do período de testes da organização parceira.',
  OrgCannotChangePartnerStatusWarning:
    'O status de organização parceira desta organização não pode ser alterado enquanto ela tiver organizações filhas.',
  IsPartner: 'É Partner',
  IsBlocked: 'Está bloqueado',
  DisplayName: 'Nome de exibição',
  Email: 'E-mail',
  PleaseEnterAValidEmail: 'Por favor, insira um email válido',
  Address: 'Endereço',
  PleaseEnterAnAddress: 'Por favor, insira um endereço',
  PartnerOrganization: 'Organização Parceira',
  EnsureDB: 'Garantir DB',
  Unblock: 'Desbloquear',
  Block: 'Bloquear',
  AddMembersToOrganization: 'Adicionar membros à organização',
  OrganizationMembers: 'Membros da organização',
  OrganizationParam: 'Organization {0}',
  NewOrganization: 'Nova organização',
  CreationOrganizationMessage: 'Criando organização e seu banco de dados. Isso pode levar vários minutos. Por favor, aguarde',
  RoleAssignments: 'Atribuições de função',
  Identity: 'Identidade',
  SelectType: 'Selecionar tipo',
  Group: 'Grupo',
  IdentityType: 'Tipo de identidade',
  SearchIdentity: 'Identidade de pesquisa',
  NewRolesAssignment: 'Nova atribuição de funções',
  Visibility: 'Visibilidade',
  PleaseSelect: 'Por favor, selecione',
  Category: 'Categoria',
  PleaseEnterACategory: 'Por favor, insira uma categoria',
  AssignNewRolesToPermission: 'Atribuir novas funções à permissão',
  PermissionParam: 'Permissão {0}',
  NewPermission: 'Nova permissão',
  Organization: 'Organização',
  AddRoleToGroups: 'Adicionar função a grupos',
  AreYouSureRemoveRole: 'Tem certeza de que deseja remover a função de',
  RoleGroups: 'Grupos de funções',
  AddToGroups: 'Adicionar a grupos',
  AddPermissionsToRole: 'Adicionar permissões à função',
  Permission: 'Permissão',
  RolePermissions: 'Permissões de função',
  AddToPermissions: 'Adicionar às permissões',
  AddUsersToRole: 'Adicionar usuários à função',
  RoleUsers: 'Usuários de função',
  AddUsers: 'Adicionar usuários',
  RolParam: 'Papel {0}',
  NewRole: 'Nova função',
  AddUserToGroups: 'Adicionar usuário a grupos',
  AreYouSureRemoveUserFromGroup: 'Tem certeza que deseja remover o usuário do grupo {0}',
  AreYouSureRemoveUserFromGroups: 'Tem certeza de que deseja remover o usuário de {0} grupos',
  GroupMembership: 'Associação do grupo',
  AssignPermissionsToUser: 'Atribuir permissões ao usuário',
  AssignNewRolesToUser: 'Atribuir novas funções ao usuário',
  UserParam: 'Usuário {0}',
  PasswordMustMatch: 'A senha deve corresponder',
  NewUser: 'Novo usuário',
  PleaseSelectAnOrganization: 'Por favor, selecione uma organização',
  SetPassword: 'Definir senha',
  SendInvitation: 'Enviar convite',
  Password: 'Senha',
  ConfirmPassword: 'Confirmar senha',
  PasswordFieldBlankMessage:
    'Se você deixar o campo de senha em branco, o sistema assumirá que este usuário usará um provedor de autenticação externo para fazer login',
  AdminZone: 'Zona de administração',
  ReviewClaims: 'Revisar Reivindicações',
  ReviewGrants: 'Revisar Subsídios',
  PageDoesNotExist: 'Desculpe, a página que você visitou não existe',
  BackHome: 'Voltar a Home',
  Home: 'Home',
  DontHaveAccessToTheAdminSite: 'Você não tem acesso ao site de administração',
  RedirectingToLandingPage: 'Redirecionando para a página de destino em',
  Go: 'Ir',
  DefaultLanguage: 'Idioma padrão',
  PleaseSelectALanguage: 'Por favor, selecione um idioma',
  SelectLanguage: 'Selecionar idioma',
  Languages: 'Idiomas',
  to: 'para',
  from: 'de',
  DownloadTemplate: 'Baixar modelo',
  ConfirmationRequired: 'Confirmação necessária',
  Confirmation: 'Confirmação',
  AreYouSureDeleteAllItems: 'Tem certeza de que deseja excluir todos os itens?',
  AreYouSureYouWantToDelete: 'Tem certeza de que deseja excluir os itens selecionados?',
  AreYouSureYouWantToDeleteSelected: 'Tem certeza de que deseja excluir os itens selecionados?',
  UploadComplete: 'Upload completo',
  DeleteElements: 'Excluir elementos',
  DeleteItems: 'Excluir elementos',
  DeleteSelected: 'Excluir selecionado',
  BulkUploadItems: 'Carregar itens em massa',
  DeleteAll: 'Excluir tudo',
  OrderBy: 'Encomendar por',
  AnErrorOcurred: 'Ocorreu um erro',
  NoData: 'Sem dados',
  ResetFilter: 'Redefinir filtro',
  SelectAll: 'Selecionar tudo',
  FilterConfirm: 'Filter confirm',
  Filter: 'Filtro',
  InvertSelection: 'Inverter seleção',
  Sort: 'Ordenar',
  ElementsDeletedSuccessfully: 'Os elementos foram excluídos com sucesso',
  AreYouSureDiscardChanges: 'Tem certeza de que deseja descartar essas alterações?',
  TotalElements: 'Total de elementos',
  TotalImported: 'Total importado',
  DownloadErrorsFile: 'Baixar arquivo de erros',
  Errors: 'Erros',
  DownloadWarningsFile: 'Baixar arquivo de avisos',
  Warnings: 'Avisos',
  UnsavedValuesWarning: 'Existem alterações não salvas, tem certeza que deseja sair?',
  DeletedElements: 'Elementos excluídos',
  FailDeletion: 'Falha na exclusão',
  NotSet: 'Não definido',
  CanNotDeleteOwnUser: 'Não é possível excluir o próprio usuário',
  CanNotDeleteOwnOrganization: 'Não é possível excluir a própria organização',

  //Home
  WelcomeBack: 'Bem-vindo de volta, {0}!',
  PageDoesNotExists: 'Desculpe, a página que você visitou não existe.',

  //Paging
  Page: 'Página',
  GoTo: 'Ir para',

  //Roles Views
  Selector: 'Selector',
  AssignToScopeCreator: 'Atribuir ao criador de escopo',
  EditRole: 'Editar função',
  Edit: 'Editar',
  EditDefaultRole: 'Editar função padrão',
  CreateDefaultRole: 'Criar função padrão',
  NewDefaultRole: 'Nova função padrão',
  DeleteMember: 'Excluir membro',
  DeleteMembers: 'Excluir membros',
  RemoveMember: 'Excluir membro',
  RemoveMembers: 'Excluir membros',
  CreateRole: 'Criar função',
  RolesPermissions: 'Permissões de papéis',
  GeneralProperties: 'Propriedades Gerais',
  SelectSelector: 'Selecionar seletor',
  AssignByDefaultToScopeCreator: 'Atribuir por padrão ao Scope Creator',
  SaveChanges: 'Salvar alterações',
  Allow: 'Permitir',
  Deny: 'Negar',
  Partners: 'Parceiros',
  EditAdminRole: 'Editar função de administrador',
  RoleName: 'Nome da função',
  NewAdminRole: 'Nova função de administrador',
  PartnersOnlyPergunta: 'Somente parceiros?',
  PartnersOnly: 'Somente parceiros',
  DefaultRoleWarning:
    'Esta função padrão gera funções que estão sendo atribuídas por padrão aos criadores de alguns tipos de escopos. Prossiga com cuidado',
  DefaultRoleDeleteAviso:
    'Esta função padrão gera funções que estão sendo atribuídas por padrão aos criadores de alguns tipos de escopos. Tem certeza de que deseja excluí-lo?',
  ChooseIdentity: 'Escolher identidade:',
  RoleIsBeingAssignedToDefaultCreators: 'Esta função está sendo atribuída por padrão aos criadores de alguns tipos de escopos. Prossiga com cuidado',
  RoleIsBeingAssignedToDefaultCreatorsDelete:
    'Esta função está sendo atribuída por padrão aos criadores de alguns tipos de escopos. Tem certeza de que deseja excluí-lo?',
  RoleDelete: 'Tem certeza de que deseja excluir esta função?',
  DefaultRoleDelete: 'Tem certeza de que deseja excluir esta função padrão?',
  //Permissions
  PleaseEnterADescription: 'Por favor, insira uma descrição',
  AddNewRolesToPermission: 'Adicionar novas funções à permissão',
  DeleteRole: 'Excluir função',
  DeleteRoles: 'Excluir funções',
  AddNewPermission: 'Adicionar nova permissão',
  AddPermission: 'Adicionar permissão',
  //Admin
  CreatePartnerOrganization: 'Criar organização parceira',
  DeletePartnerOrganization: 'Excluir organização parceira',
  ManageDefaultRoles: 'Gerenciar funções padrão',
  ManagePermissions: 'Gerenciar permissões',
  //Partners
  BlockOrganization: 'Bloquear Organização',
  CreateOrganization: 'Criar Organização',
  DeleteOrganization: 'Excluir Organização',
  ManageLicenses: 'Gerenciar Licenças',
  ManageRoleAssignment: 'Gerenciar atribuições de função',
  //Organization
  CreateProject: 'Criar projeto',
  ManageGroups: 'Gerenciar grupos',
  ManageOrganizationInfo: 'Gerenciar informações da organização',
  ManageOrganizationRoleAssignments: 'Gerenciar atribuições de funções da organização',
  ManageQuarantine: 'Gerenciar quarentena',
  ManageRecycleBin: 'Gerenciar Lixeira',
  ManageRoles: 'Gerenciar funções',
  ManageUnitSystem: 'Gerenciar sistema de unidade',
  ManageUsers: 'Gerenciar usuários',
  AddOrganization: 'Adicionar Organização',
  //Project
  CreateDrillhole: 'Criar Furo',
  DeleteProject: 'Excluir projeto',
  ManageProjectInfo: 'Gerenciar informações do projeto',
  ManageProjectRoleAssignments: 'Gerenciar atribuições de funções do projeto',
  ViewProjectData: 'Exibir dados do projeto',
  //Ring
  CreateRing: 'Criar ring',
  DeleteRing: 'Excluir ring',
  ManageRingInfo: 'Gerenciar informações do ring',
  ManageRingRoleAssignments: 'Gerenciar atribuições de funções de ring',
  ShareRing: 'Compartilhar ring',
  ViewRingData: 'Ver dados do ring',
  CreateRingDrillhole: 'Criar furos de ring',
  //Drillhole
  DeleteDrillhole: 'Excluir sondagem',
  ManageDrillholeInfo: 'Gerenciar informações do furo de sondagem',
  ManageDrillholeRoleAssignments: 'Gerenciar atribuições de função de perfuração',
  ViewDrillholeData: 'Visualizar dados do furo de sondagem',
  ManageSurveys: 'Gerenciar pesquisas',
  SynchronizeSurveys: 'Sincronizar pesquisas',

  //GroupViews
  RowsSelected: 'linha(s) selecionada(s)',
  AddToMembers: 'Adicionar aos membros',
  AssignRolesToGroup: 'Atribuir funções ao grupo',
  Scope: 'Escopo',
  ScopeType: 'Tipo de Escopo',
  SearchScope: 'Escopo de pesquisa',
  AddGroup: 'Adicionar grupo',
  AddNewGroup: 'Adicionar novo grupo',
  DeleteGroup: 'Excluir grupo',
  DeleteGroups: 'Excluir grupos',
  GroupInfo: 'Informações do grupo',
  GroupMembers: 'Membros do Grupo',
  CheckGroupInfoAndUsersTabs: 'Por favor, verifique as informações do grupo e as guias de membros. Algo está errado',

  //Organizations:
  PleaseCheckTheInfoProvided: 'Por favor, verifique as informações fornecidas. Algo está errado',
  PleaseSelectOrRemoveRow: 'Por favor, selecione ou remova a linha',
  AreYouSureRemoveMemberFromOrg: 'Tem certeza de que deseja remover {0} membro da organização?',
  AreYouSureRemoveMembersFromOrg: 'Tem certeza de que deseja remover {0} membros da organização?',
  DeleteUsers: 'Excluir usuários',
  InvitationSent: 'Convite Enviado',
  InvitationNotSent: 'Convite não enviado',
  ResendInvitation: 'Reenviar convite',
  SendResetPasswordEmail: 'Enviar e-mail de redefinição de senha',
  ResetPasswordEmailSent: 'Email Enviado',
  ResetPasswordEmailNotSent: 'E-mail não enviado',
  TypeOrganizationNameToConfirm: 'Digite o nome da organização para confirmar',
  CanNotDeletePartnerOrganizations: 'Não é possível excluir organizações parceiras',
  CanNotDeleteOrganizations: 'Não é possível excluir organizações',
  CheckOrganizationInfoAndUsersTabs: 'Por favor, verifique as informações da organização e guias de usuários. Algo está errado',
  AddNewOrganization: 'Adicionar nova organização',
  SelectOrInviteOrganizationMaster: 'Selecione ou convide o mestre da organização',
  PleaseSelectInviteOrRemoveRow: 'Por favor, selecione, convide ou remova a linha',
  AddUser: 'Adicionar usuário',
  AddNewUser: 'Adicionar novo usuário',

  //Users
  RemoveMembership: 'Remover associação',
  RemoveMemberships: 'Remover Associações',
  UsersLogs: 'Registros do usuário',
  AssignRolesToUser: 'Atribuir funções ao usuário',
  RolesAssigned: 'Funções Atribuídas',
  BalnkPasswordAviso:
    'Se você deixar o campo de senha em branco, o sistema assumirá que este usuário usará um provedor de autenticação externo para fazer login.',
  DeleteUser: 'Excluir usuário',
  ConfirmDeleteUser: 'Tem certeza que deseja excluir o usuário "{0}" com endereço de e-mail "{1}"?',
  UserDeleted: 'Usuário "{0}" com endereço de e-mail "{1}" foi excluído com sucesso.',
  //AuditLogs
  Timestamp: 'Carimbo de data e hora',
  DisplayingFilteredItems: 'Exibindo itens filtrados por uma notificação.',
  ShowAllItems: 'Mostrar todos os itens',
  NotificationTimestampMessageMinutes: 'há {0} minutos',
  NotificationTimestampMessageHours: 'há {0} horas',
  Yesterday: 'Ontem',
  Read: 'Lido',
  Unread: 'Não lido',
  Action: 'Ação',
  AffectedElement: 'Elemento afetado',
  LinkTo: 'Link para',
  State: 'Estado',
  Date: 'Data',
  Notifications: 'Notificações',
  NotificationStatus: 'Status da notificação',
  InApp: 'No aplicativo',
  NotificationsSettings: 'Configurações de notificações',
  DeleteAfter: 'Excluir após',
  OneWeek: 'Uma semana',
  OneMonth: 'Um mês',
  OneYear: 'Um ano',
  ThreeMonths: 'Três meses',
  SixMonths: 'Seis meses',
  DeleteAllNotifications: 'Excluir todas',
  SurveySynchedRingNotificationDescription: 'O survey "{A}" foi sincronizado no furo de sondagem "{B}".',
  SurveySynchedDrillholeNotificationDescription: 'O survey "{A}" foi sincronizado no Ring "{B}".',
  SurveySynchedQuarantineNotificationDescription: 'O survey "{A}" foi sincronizado na quarentena.',
  OrganizationCreationFinishedNotificationTitle: 'Organização criada',
  OrganizationExpirationWarningNotificationTitle: 'A organização está prestes a expirar',
  OrganizationCreationErrorNotificationTitle: 'Erro ao criar organização',
  OrganizationIsAvailableNotificationTitle: 'Organização disponível',
  LicenseNeedsApprovalNotificationTitle: 'A licença precisa de aprovação',
  LicenseWasRenewedNotificationTitle: 'A licença foi renovada',
  RingCreatedNotificationTitle: 'Ring criado',
  SurveySynchedNotificationTitle: 'Survey sincronizado',
  ProjectDeletedNotificationTitle: 'Projeto excluído',
  ProjectEditedNotificationTitle: 'Projeto editado',
  DrillholeDeletedNotificationTitle: 'Furo de sondagem excluído',
  RingDeletedNotificationTitle: 'Ring excluído',
  DrillholeMovedNotificationTitle: 'Furo de sondagem movido',
  RingMovedNotificationTitle: 'Ring movido',
  DrillholeEditedNotificationTitle: 'Furo de sondagem atualizado',
  RingEditedNotificationTitle: 'Ring atualizado',
  SurveySignoffNotificationTitle: 'Solicitação de aprovação de survey',
  DrillholeCreatedNotificationTitle: 'Furo de sondagem criado',
  BulkDrillholesUpdateNotificationTitle: 'Furos de sondagem editados',
  BulkDrillholesMovedNotificationTitle: 'Furos de sondagem movidos',
  BulkRingsMovedNotificationTitle: 'Rings movidos',
  BulkDrillholesDeletedNotificationTitle: 'Furos de sondagem excluídos',
  BulkRingsDeletedNotificationTitle: 'Rings excluídos',
  BulkProjectsDeletedNotificationTitle: 'Projetos excluídos',
  BulkRingsCreatedNotificationTitle: 'Rings criados',
  BulkDrillholesCreatedNotificationTitle: 'Furos de sondagem criados',
  SurveyDeletedNotificationTitle: 'Survey excluído',
  SurveyDeletedNotificationDescription: 'O survey "{A}" foi excluído.',

  OrganizationCreationFinishedNotificationDescription: 'A organização {A} foi criada com {X} membros.',
  OrganizationExpirationWarningNotificationDescription: 'A organização {A} está prestes a expirar.',
  OrganizationCreationErrorNotificationDescription: 'Ocorreu um erro ao criar a organização {A}.',
  OrganizationIsAvailableNotificationDescription: 'A organização {A} está disponível agora.',
  LicenseNeedsApprovalNotificationDescription: 'Uma licença com o código da ferramenta {A} precisa de aprovação.',
  LicenseWasRenewedNotificationDescription: 'Uma licença com o código da ferramenta {A} foi renovada.',
  SurveySynchedNotificationDescription: 'O survey "{A}" foi sincronizado no furo de sondagem "{B}".',
  ProjectDeletedNotificationDescription: 'O projeto "{A}" foi excluído.',
  ProjectEditedNotificationDescription: 'O projeto "{A}" foi editado.',
  DrillholeDeletedNotificationDescription: 'O furo de sondagem "{A}" foi excluído.',
  RingDeletedNotificationDescription: 'O Ring "{A}" foi excluído.',
  DrillholeMovedNotificationDescription: 'O furo de sondagem "{B}" foi movido para "{A}".',
  RingMovedNotificationDescription: 'O Ring "{B}" foi movido para o projeto "{A}".',
  DrillholeEditedNotificationDescription: 'O furo de sondagem "{A}" foi atualizado',
  RingEditedNotificationDescription: 'O Ring "{A}" foi atualizado',
  SurveySignoffNotificationDescription: 'Foi solicitada uma aprovação para o survey "{A}".',
  DrillholeCreatedNotificationDescription: 'Um furo de sondagem com o nome "{B}" foi criado em "{A}".',
  RingCreatedNotificationDescription: 'Um Ring com o nome "{B}" foi criado no projeto "{A}".',
  BulkDrillholesUpdateNotificationDescription: '{X} furos de sondagem foram editados em "{B}".',
  BulkDrillholesMovedNotificationDescription: '{X} furos de sondagem foram movidos para "{B}".',
  BulkRingsMovedNotificationDescription: '{X} Rings foram movidos para o projeto "{B}".',
  BulkDrillholesDeletedNotificationDescription: '{X} furos de sondagem foram excluídos',
  BulkRingsDeletedNotificationDescription: '{X} Rings foram excluídos',
  BulkProjectsDeletedNotificationDescription: '{X} projetos foram excluídos.',
  BulkRingsCreatedNotificationDescription: '{X} Rings foram criados.',
  BulkDrillholesCreatedNotificationDescription: '{X} furos de sondagem foram criados em "{B}".',
  ForgotPasswordNotificationTitle: 'E-mail de redefinição de senha enviado',
  OrganizationInvitationNotificationTitle: 'Convite para organização recebido',
  LicenseQRSharedNotificationTitle: 'Licença compartilhada com você',
  ToolUsageReportNotificationTitle: 'Relatório de uso de ferramentas pronto',
  OrganizationCreationFinishedNotificationTitleError: 'Erro ao criar organização',
  OrganizationIsAvailableNotificationTitleError: 'Erro ao disponibilizar organização',
  LicenseWasRenewedNotificationTitleError: 'Erro ao renovar licença',
  RingCreatedNotificationTitleError: 'Erro ao criar Ring',
  SurveySynchedNotificationTitleError: 'Erro ao sincronizar survey',
  ProjectDeletedNotificationTitleError: 'Erro ao excluir projeto',
  ProjectEditedNotificationTitleError: 'Erro ao editar projeto',
  DrillholeDeletedNotificationTitleError: 'Erro ao excluir furo de sondagem',
  RingDeletedNotificationTitleError: 'Erro ao excluir Ring',
  DrillholeMovedNotificationTitleError: 'Erro ao mover furo de sondagem',
  RingMovedNotificationTitleError: 'Erro ao mover Ring',
  DrillholeEditedNotificationTitleError: 'Erro ao atualizar furo de sondagem',
  RingEditedNotificationTitleError: 'Erro ao atualizar Ring',
  DrillholeCreatedNotificationTitleError: 'Erro ao criar furo de sondagem',
  BulkDrillholesUpdateNotificationTitleError: 'Erro ao editar furos de sondagem',
  BulkDrillholesMovedNotificationTitleError: 'Erro ao mover furos de sondagem',
  BulkRingsMovedNotificationTitleError: 'Erro ao mover Rings',
  BulkDrillholesDeletedNotificationTitleError: 'Erro ao excluir furos de sondagem',
  BulkRingsDeletedNotificationTitleError: 'Erro ao excluir Rings',
  BulkProjectsDeletedNotificationTitleError: 'Erro ao excluir projetos',
  BulkRingsCreatedNotificationTitleError: 'Erro ao criar Rings',
  BulkDrillholesCreatedNotificationTitleError: 'Erro ao criar furos de sondagem',
  SurveyDeletedNotificationTitleError: 'Erro ao excluir survey',
  ForgotPasswordNotificationTitleError: 'Erro ao enviar e-mail de redefinição de senha',
  OrganizationInvitationNotificationTitleError: 'Erro ao enviar convite para organização',
  LicenseQRSharedNotificationTitleError: 'Erro ao compartilhar licença',
  ToolUsageReportNotificationTitleError: 'Erro ao gerar relatório de uso da ferramenta',

  SurveyDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o survey "{A}".',
  OrganizationCreationFinishedNotificationDescriptionError: 'Ocorreu um erro ao criar a organização {A}.',
  OrganizationIsAvailableNotificationDescriptionError: 'Ocorreu um erro ao disponibilizar a organização {A}.',
  LicenseWasRenewedNotificationDescriptionError: 'Ocorreu um erro ao renovar a licença com o código da ferramenta {A}.',
  SurveySynchedNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" no furo de sondagem "{B}".',
  ProjectDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o projeto "{A}".',
  ProjectEditedNotificationDescriptionError: 'Ocorreu um erro ao editar o projeto "{A}".',
  DrillholeDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o furo de sondagem "{A}".',
  RingDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir o Ring "{A}".',
  DrillholeMovedNotificationDescriptionError: 'Ocorreu um erro ao mover o furo de sondagem "{B}" para "{A}".',
  RingMovedNotificationDescriptionError: 'Ocorreu um erro ao mover o Ring "{B}" para o projeto "{A}".',
  DrillholeEditedNotificationDescriptionError: 'Ocorreu um erro ao atualizar o furo de sondagem "{A}".',
  RingEditedNotificationDescriptionError: 'Ocorreu um erro ao atualizar o Ring "{A}".',
  DrillholeCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar o furo de sondagem "{A}" em "{B}".',
  RingCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar o Ring "{A}" no projeto "{B}".',
  BulkDrillholesUpdateNotificationDescriptionError: 'Ocorreu um erro ao editar {X} furos de sondagem em "{B}".',
  BulkDrillholesMovedNotificationDescriptionError: 'Ocorreu um erro ao mover {X} furos de sondagem para "{A}".',
  BulkRingsMovedNotificationDescriptionError: 'Ocorreu um erro ao mover {X} Rings para o projeto "{A}".',
  BulkDrillholesDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir {X} furos de sondagem.',
  BulkRingsDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir {X} Rings.',
  BulkProjectsDeletedNotificationDescriptionError: 'Ocorreu um erro ao excluir {X} projetos.',
  BulkRingsCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar {X} Rings.',
  BulkDrillholesCreatedNotificationDescriptionError: 'Ocorreu um erro ao criar {X} furos de sondagem em "{B}".',
  ForgotPasswordNotificationDescriptionError: 'Ocorreu um erro ao enviar o e-mail de redefinição de senha.',
  OrganizationInvitationNotificationDescriptionError: 'Ocorreu um erro com um convite para a organização. Verifique.',
  LicenseQRSharedNotificationDescriptionError: 'Ocorreu um erro ao compartilhar a licença.',
  ToolUsageReportNotificationDescriptionError: 'Ocorreu um erro ao gerar ou enviar o relatório de uso da ferramenta.',
  SurveySynchedRingNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" no furo de sondagem "{B}".',
  SurveySynchedDrillholeNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" no Ring "{B}".',
  SurveySynchedQuarantineNotificationDescriptionError: 'Ocorreu um erro ao sincronizar o survey "{A}" na quarentena.',
  IsRead: 'Lido',
  RelatedEntityName: 'Nome da entidade relacionada',
  RelatedEntityType: 'Tipo da entidade relacionada',
  RedirectEntityName: 'Nome da entidade de redirecionamento',
  RedirectEntityType: 'Tipo da entidade de redirecionamento',
  Count: 'Quantidade',
  Enable: 'Habilitar',
  SendNotificationsViaEmail: 'Enviar notificações por e-mail',
  TypeHeader: 'Tipo',

  ForgotPasswordNotificationDescription: 'Um e-mail contendo um link para redefinição de senha foi enviado.',
  OrganizationInvitationNotificationDescription: 'Você foi convidado para participar de uma organização. Verifique seu e-mail para mais detalhes.',
  LicenseQRSharedNotificationDescription: 'Uma licença foi compartilhada com você. Verifique seu e-mail para mais detalhes.',
  ToolUsageReportNotificationDescription: 'O relatório de uso de ferramentas foi gerado com sucesso e enviado para o seu e-mail.',

  Now: 'Agora',
  EmptyNotificationsTextTitle: 'Você está em dia!',
  EmptyNotificationsTextSubtitle: 'Você não tem novas notificações',
  LastWeek: 'Semana passada',
  Today: 'Hoje',
  ThisWeek: 'Esta semana',
  ThisMonth: 'Este mês',
  MarkAsRead: 'Marcar como lida',
  MarkAsReadAll: 'Marcar como lidas',
  LogType: 'Tipo de Log',
  RelatedEntity: 'Entidade Relacionada',
  // Error
  UnexpectedError: 'Erro inesperado',
  Unauthorized: 'Não autorizado',
  NoAccessToAdminSite: 'Você não tem acesso ao site de administração',
  LoginOutInSecs: 'Faça logout em {0} segundos',
  CrashError: 'Ops! Algo deu muito errado',
  SeeAllLogs: 'Por favor, pressione F12 e envie todos os logs na guia Console ao relatar este incidente',
  ReturnHome: 'Voltar para casa',
  OrganizationUsers: 'Usuários da organização',
  IsPartnerQuestion: 'É parceiro?',

  FixResult: 'Corrigir resultado',
  NoInconsistenciesFound: 'Nenhuma inconsistência encontrada',
  Type: 'Tipo',
  Parent: 'Pai',
  'Parent Type': 'Tipo pai',
  Problem: 'Problema',
  Fixed: 'Corrigido',
  SomethingWentWrong: 'Algo deu errado',
  PleaseTryAgainLater: 'Por favor, tente novamente mais tarde',
  FixInconsistencies: 'Corrigir inconsistências',
  AssignRoleWarning:
    'Você está atribuindo funções: {0} a {1} em nível de organização. Como funções serão aplicadas a todas as entidades selecionadas e {1} terá permissão para todas as informações contidas em {2}',
  UpdateExpiredRoleWarning:
    'Os papéis: {0} foram previamente atribuídos a {1}, mas expiraram. A data selecionada substituirá a data de expiração anterior e os papéis voltarão a ficar ativos.',
  DoYouWantToContinue: 'Deseja continuar?',
  MemberAlreadyInOrganizarion: 'O usuário já é membro da organização {0}',
  YouHaveSelectedThisUserMoreThanOnce: 'Você selecionou este usuário mais de uma vez',
  ElementsSussessfulyDeleted: 'Elementos sucessivamente deletados',
  rowsSelected: 'linha(s) selecionada(s)',
  ImportCSV: 'Importar CSV',
  Licenses: 'Licenças',
  ToolCode: 'Código da ferramenta',
  DeviceType: 'Tipo de dispositivo',
  FromDate: 'Desde a data',
  UntilDate: 'Até a data',
  CreatedOn: 'Até a data',
  CreatedBy: 'Criado por',
  Unlimited: 'Ilimitado',
  Coefficients: 'Coeficientes',
  Continuous: 'Contínuo',
  Multishot: 'Multishot',
  Zupt: 'Zup',
  Offline: 'Off-line',
  Flash: 'Flash',
  Notes: 'Notas',
  AddLicense: 'Adicionar licença',
  AddNewLicense: 'Adicionar nova licença',
  PleaseEnterToolCode: 'Por favor, insira o código da ferramenta',
  LicenseCopied: 'Licença copiada para a área de transferência',
  License: 'Licença',
  Copy: 'Copiar',
  ErrorLoadingLicense: 'Erro ao carregar licença',
  ShowLicense: 'Exibir licença',
  GoToLicense: 'Ir para a licença',
  LicenseAlreadyExists: 'Já existe uma licença com os mesmos parâmetros que você digitou',
  PeriodOfValidity: 'Período de Validade',
  CopyLicense: 'Copiar Licença',
  CopyAll: 'Copiar tudo',
  PleaseSelectDates: 'Selecione Datas',
  Project: 'Projeto',
  Customer: 'Cliente',
  ExportCSV: 'Exportar CSV',
  Reports: 'Relatórios',
  Export: 'Exportar',
  Separator: 'Relatórios',
  Tab: 'Aba',
  Semicolon: 'Ponto e vírgula',
  Comma: 'Vírgula',
  ThereWasAProblemCreatingLicense: 'Ocorreu um problema ao criar a licença. Por favor, entre em contato com um administrador.',
  ExpirationDate: 'Data de Expiração',
  UpdateRoleAttributes: 'Editar atributos de função',
  Update: 'Atualizar',
  AllowedDevices: 'Dispositivos permitidos',
  RoleExpirationDate: 'Data de vencimento da função',
  PleaseEnterExpirationDate: 'Por favor, insira uma data de validade',
  MaximumLicenseDueDate: 'Data máxima de vencimento da licença',
  PleaseEnterMaxDueDate: 'Por favor, insira a data máxima de vencimento da licença',
  MaxLicensesPeriodInDays: 'Período Máximo de Licença em Dias',
  PleaseEnterMaxLicensesPeriodInDays: 'Por favor, insira o período máximo de licença em dias',
  MaxNumberOfLicensesPerMonth: 'Número máximo de licenças por mês',
  PleaseEnterMaxNumberOfLicensesPerMonth: 'Por favor, insira o número máximo de licenças por mês',
  SignOffPending: 'Aprovação Pendente',
  SignedOffBy: 'Aprovado por',
  SignedOffOn: 'Aprovado em',
  SignOff: 'Aprovação',
  Refuse: 'Recusar',
  NeedsSignOff: 'Aprovação necessária',
  SelectedUserAlreadyHasTheSelectedRoles: 'O usuário selecionado já possui as funções: {0}.',
  CanCreateUnlimitedLicense: 'Pode criar licenças que não expiram',
  CanCreateRecurrentLicenses: 'Pode criar licenças recorrentes',
  Recurrence: 'Recorrência',
  Activated: 'Ativado',
  Deactivated: 'Desativado',

  Logs: 'Logs',
  LicenseLogs: 'Logs de licença',
  ViewLogs: 'Visualizar logs',
  UserName: 'Nome de utilizador',
  LicenseCreation: 'Criação de licença',
  LicenseUpdate: 'Actualização da licença',
  LicenseSignedOff: 'Licença cancelada',
  LicenseRejected: 'Licença Rejeitada',
  ErrorCreatingLicenseMaximumLicenseDueDate: 'Erro ao criar a licença',
  ErrorCreatingLicenseMaxLicensesPeriodInDays: 'Erro ao criar a licença',
  ErrorCreatingLicenseMaxLicenseNumber: 'Erro ao criar a licença',
  ErrorCreatingLicenseAllowedDevices: 'Erro ao criar a licença',
  ErrorUpdatingLicenseMaximumLicenseDueDate: 'Erro ao actualizar a licença',
  ErrorUpdatingLicenseMaxLicensesPeriodInDays: 'Erro ao actualizar a licença',
  ErrorUpdatingLicenseAllowedDevices: 'Erro ao actualizar a licença',
  LicenseCreationDescription: 'Uma licença foi criada por {0} para o dispositivo {1} e tipo de ferramenta {2}',
  LicenseUpdateDescription: 'Uma licença foi actualizada por {0}',
  LicenseCreationDescriptionExtraData:
    'Uma licença foi criada por {0} com os seguintes parâmetros: Tipo de dispositivo: {1}, Número da ferramenta: {2}, {3}, Projeto: {4}, Cliente: {5}.',
  LicenseUpdateDescriptionExtraData:
    'Uma licença foi atualizada por {0}.<br> Parâmetros anteriores: Tipo de dispositivo: {1}, Número da ferramenta: {2}, {3}, Projeto: {4}, Cliente: {5}.<br> Parâmetros atuais: Tipo de dispositivo: {6}, Número da ferramenta: {7}, {8}, Projeto: {9}, Cliente: {10}.',
  LicenseDescriptionTimeData: 'de {0} até {1}',
  LicenseSignedOffDescription: '{0} assinou a licença criada por {1} para o dispositivo {2} e o tipo de ferramenta {3}',
  LicenseRejectedDescription: '{0} licença rejeitada criada por {1} para o dispositivo {2} e o tipo de ferramenta {3}',
  ErrorCreatingLicenseMaximumLicenseDueDateDescription:
    'Ocorreu um erro ao criar a licença. A licença não pode ter uma data de vencimento posterior à data de vencimento máxima permitida',
  ErrorCreatingLicenseMaxLicensesPeriodInDaysDescription:
    'Ocorreu um erro ao criar a licença. A licença deve ser válida por um período inferior ao período máximo de licença permitido',
  ErrorCreatingLicenseMaxLicenseNumberDescription:
    'Ocorreu um erro ao criar a licença. O utilizador excedeu o número máximo de licenças que podem ser criadas num mês',
  ErrorCreatingLicenseAllowedDevicesDescription:
    'Ocorreu um erro ao criar a licença. O utilizador não tem permissões para criar licenças para o dispositivo especificado',
  ErrorUpdatingLicenseMaximumLicenseDueDateDescription:
    'Ocorreu um erro ao actualizar a licença. A licença não pode ter uma data de vencimento posterior à data de vencimento máxima permitida',
  ErrorUpdatingLicenseMaxLicensesPeriodInDaysDescription:
    'Ocorreu um erro ao actualizar a licença. A licença deve ser válida por um período inferior ao período máximo de licença permitido',
  ErrorUpdatingLicenseAllowedDevicesDescription:
    'Ocorreu um erro ao actualizar a licença. O utilizador não tem permissões para definir licenças para o dispositivo especificado.',
  ExportingVeryLargeNumberOfItems:
    'Está a tentar exportar um número muito elevado de itens, o que pode demorar algum tempo. Tem a certeza de que pretende continuar?',
  InitializingOrganization: 'Inicializando a organização. Os usuários estarão disponíveis em breve',
  InvalidToolCode: 'O código da ferramenta tem de ter exatamente quatro dígitos',
  EditRoles: 'Editar funções',
  EditRolesMessage: 'Editar funções do usuário',
  RolesWillBeRemoved: 'As seguintes funções serão removidas: {0}. ',
  RolesWillBeAssigned: 'As seguintes funções serão atribuídas: {0}. ',
  LicenseAttributesWillBeUpdated: 'Os atributos para a função License Manager serão atualizados.',
  CheckDatabases: 'Verificar bases de dados',
  CheckDatabasesComplete: 'A operação de verificação das bases de dados está concluída',
  DatabaseCheckResultsModalTitle: 'Resultados da verificação da base de dados:',
  ViewResults: 'Ver resultados',
  CheckDatabaseResult: 'Resultado da verificação da base de dados',
  OrganizationName: 'Nome da organização',
  Status: 'Status',
  Success: 'Sucesso',
  Error: 'Erro',
  AddAssignments: 'Adicionar atribuições',
  GroupsLogs: 'Logs do grupo',
  RelatedUser: 'Usuário relacionado',
  OrganizationInfo: 'Informações da organização',
  LicenseDetails: 'Detalhes da licença',
  DatabaseCheckLogs: 'Registos de verificação da base de dados',
  CheckingDatabases: 'Verificação das bases de dados...',
  DatabaseLogs: 'Registos da base de dados',
  DatabaseCheckLogsResult: 'Resultados da verificação da base de dados',
  DatabaseCheckResultOnDate: 'Resultado da verificação da base de dados em {0}',
  ExportingProcessStarted: 'O processo de exportação foi iniciado, a transferência começará em breve',
  ExportOrganization: 'Exportar Organização',
  ImportOrganization: 'Importar Organização',
  UploadOrganizationBackup: 'Carregar cópia de segurança da organização',
  AddOrganizationFile: 'Clique ou arraste o ficheiro de cópia de segurança da organização para esta área para carregar',
  ThisUserIsOrganizationMaster: 'Este usuário já foi selecionado como mestre da organização',
  RemainingLicensesMessage: 'Você tem um total de {0} licenças restantes para este mês',
  MaxLicenseNumberReached: 'Você atingiu o número máximo de licenças para este mês',
  EULATitle: 'Contrato de licença de usuário final (EULA)',
  OrganizationIsExporting: 'A organização está a exportar, aguarde...',
  ErrorExportingOrganization: 'Ocorreu um erro ao exportar a organização {0}. Por favor, tente novamente',
  ExportingOrganizationSuccess: 'O processo de exportação foi iniciado e, quando concluído, enviaremos o link de download para seu e-mail.',
  ExportImportLogs: 'Registos de exportação e importação',
  CanNotDeleteOrganizationWhileExporting:
    'A organização {0} está a ser exportada e não pode ser eliminada neste momento. Aguarde e tente novamente daqui a pouco.',
  CheckingIfOrganizationExists: 'Verificando se a organização existe...',
  RestoreOrganizationConfirmDialog:
    'Esta organização já existe, pretende continuar? Todos os dados desta organização serão sobrescritos com os dados de cópia de segurança.',
  StatusCode: 'Código de estado',
  Message: 'Mensagem',
  Traces: 'Traces',
  ViewTrace: 'Ver traço',
  ImportExportDevLogs: 'Importar e exportar registos de desenvolvimento.',
  DevLogs: 'Registos de desenvolvimento',
  DevLogsShort: 'Reg. Desenvolvimento',
  ImportExport: 'Import/Export',
  ImportingOrganizationStarted: 'O processo de importação foi iniciado',
  ImportingOrganizationSuccess: 'O processo de importação foi iniciado; quando ele for concluído, enviaremos uma notificação para seu e-mail',
  ErrorImportingOrganization: 'Ocorreu um erro ao importar a organização. Por favor, tente novamente',
  Importing: 'Importando...',
  ResetLockout: 'Redefinir bloqueio',
  LockoutReset: 'Bloqueio redefinido',
  LockoutNotReset: 'Bloqueio não redefinido',
  HangfireDashboard: 'Painel Hangfire',
  LastImportDate: 'Esta organização foi restaurada pela última vez de um backup em  ',
  EventDuration: 'Duração do evento (horas)',
  ScheduledEvents: 'Eventos programados',
  ScheduledEvent: 'Evento programado',
  VisibilityStartDate: 'Data de início da visibilidade',
  VisibilityEndDate: 'Data de fim da visibilidade',
  EventType: 'Tipo de evento',
  ScheduledUpdate: 'Atualização programada',
  Announcement: 'Anúncio',
  EventStart: 'Início do evento',
  ScheduledEventsTableError: 'Ocorreu um erro ao carregar a tabela de eventos.',
  EditScheduledEvent: 'Editar evento programado',
  NewScheduledEvent: 'Novo evento programado',
  UploadBanner: 'Carregar banner',
  Banner: 'Banner',
  BannerSelectInfoMessage:
    'As imagens de banner devem utilizar uma proporção de 8:1 (largura para altura). As resoluções recomendadas incluem 800×100 pixels, 1600×200 pixels ou qualquer outro tamanho que mantenha essa proporção. Você poderá recortar a imagem antes de salvá-la.',
  LocalizedAnnouncementInformation: 'Informações de anúncio localizadas',
  LocalizedAnnouncementInformationDescription:
    'Para cada idioma selecionado, será exibido um banner ou uma mensagem com a descrição fornecida a todos os usuários que utilizam esse idioma. Se forem fornecidos tanto um banner quanto uma descrição, a descrição será usada como texto alternativo do banner. Se o usuário utilizar um idioma não adicionado, serão utilizadas as informações do anúncio em inglês, se disponíveis, caso contrário, serão utilizadas as informações do primeiro idioma da lista.',
  AddAtLeastOneLanguage: 'Por favor, selecione pelo menos um idioma',
  PleaseEnterVisibilityRange: 'Por favor, insira um intervalo de visibilidade',
  PleaseLoadImageIfNoDescription: 'Se nenhuma descrição for fornecida, uma imagem de banner deve ser carregada',
  PleaseEnterDescriptionIfNoImage: 'Se nenhuma imagem de banner for fornecida, uma descrição em texto deve ser adicionada',
  PleaseEnterScheduledUpdateStartMoment: 'Por favor, insira um momento de início para a atualização',
  PleaseEnterScheduledUpdateDuration: 'Por favor, insira uma duração em horas para a atualização',
  Link: 'Link',
  SelectBannerArea: 'Selecionar área do banner',
  ScheduledMaintenanceText:
    'Manutenção programada: A plataforma na nuvem passará por manutenção programada em {0}. Os serviços podem ser interrompidos por uma duração estimada de {1} horas, a partir de {2}',

  AdminRolesTableError: 'Ocorreu um erro ao carregar as funções de administrador. Tente novamente',
  AuditLogsTableError: 'Ocorreu um erro ao carregar os registros de auditoria. Por favor, tente novamente',
  DefaultRolesTableError: 'Ocorreu um erro ao carregar as funções padrão. Por favor, tente novamente.',
  GroupsTableError: 'Ocorreu um erro ao carregar os grupos. Por favor, tente novamente',
  ErrorSavingGroupProperties: 'Ocorreu um erro ao salvar as propriedades do grupo. Por favor, tente novamente',
  ErrorAddingGroupMembers: 'Ocorreu um erro ao adicionar os membros ao grupo. Por favor, tente novamente.',
  GroupRolesTableError: 'Ocorreu um erro ao carregar as funções do grupo. Por favor, tente novamente.',
  LicensesTableError: 'Ocorreu um erro ao carregar as licenças. Por favor, tente novamente.',
  LicenseLogsTableError: 'Ocorreu um erro ao carregar os registros de licença. Por favor, tente novamente.',
  OrganizationsTableError: 'Ocorreu um erro ao carregar as organizações. Por favor, tente novamente.',
  ErrorAddingOrganizationMembers: 'Ocorreu um erro ao adicionar os novos membros à organização. Tente novamente.',
  ErrorRemovingOrganizationMembers: 'Ocorreu um erro ao remover os novos integrantes da organização. Tente novamente.',
  DatabaseLogsTableError: 'Ocorreu um erro ao carregar os registros do banco de dados. Por favor, tente novamente.',
  PermissionsTableError: 'Ocorreu um erro ao carregar as permissões. Por favor, tente novamente',
  ErrorSavingPermissions: 'Ocorreu um erro ao salvar as propriedades de permissão. Tente novamente.',
  ErrorAddingPermissionRoles: 'Ocorreu um erro ao adicionar permissões à função. Tente novamente.',
  ErrorRemovingPermissionRoles: 'Ocorreu um erro ao remover a permissão da função. Tente novamente.',
  RoleAssignmentsTableError: 'Ocorreu um erro ao carregar as atribuições de função. Tente novamente.',
  RoleListTableError: 'Ocorreu um erro ao carregar as funções. Por favor, tente novamente.',
  LockoutNotResetError: 'Ocorreu um erro ao redefinir o bloqueio. Por favor, tente novamente.',
  UsersTableError: 'Ocorreu um erro ao carregar a lista de usuários. Por favor, tente novamente.',
  ErrorAddingGroup: 'Ocorreu um erro ao adicionar o grupo. Por favor, tente novamente.',
  ErrorRemovingGroup: 'Ocorreu um erro ao remover o grupo. Por favor, tente novamente.',
  UserLogsTableError: 'Ocorreu um erro ao carregar os registros do usuário. Por favor, tente novamente.',
  UserRolesTableError: 'Ocorreu um erro ao carregar as funções do usuário. Por favor, tente novamente.',
  InvitationNotSentErrorMessage: 'Ocorreu um erro ao enviar o convite. Tente novamente.',
  ResetPasswordEmailNotSentMessage: 'Ocorreu um erro ao enviar o e-mail de redefinição de senha. Tente novamente.',
  ErrorEditingLicenseAttributes: 'Ocorreu um erro ao editar a licença. Tente novamente.',
  ErrorDeletingUser: 'Ocorreu um erro ao excluir o usuário. Tente novamente.',
  PaginationTotal: 'Mostrando {0} itens de {1}',
  PaginationTotalItemsText: 'Mostrando {0}-{1} de {2} itens',
  MinutesAbbreviation: 'min',
  EditTutorialInformation: 'Editar informações do tutorial',
  Order: 'Ordem',
  VideoOrder: 'Ordem do vídeo',
  FuntionTitle: 'Função',
  VideoFunction: 'Função do vídeo',
  PleaseEnterVideoOrder: 'Por favor, insira a ordem do vídeo',
  AddFunction: 'Adicionar função',
  FunctionAlreadyExistsWarning: 'Já existe uma função com esse nome. Por favor, verifique.',
  SearchTutorials: 'Pesquisar tutoriais',
  VideoTutorials: 'Tutoriais em vídeo',
  ManageVideoTutorialData: 'Gerenciar dados dos tutoriais em vídeo',
  SynchronizeThisVideoAfterOperationFinishes: 'Sincronizar este vídeo após a conclusão da operação',
  AddTutorialInformation: 'Adicionar informações do tutorial',
  VideoId: 'ID do vídeo',
  TutorialEnabledLabel: 'Este vídeo tutorial está pronto para ser visualizado pelo usuário.',
  Title: 'Título',
  FunctionTitle: 'Função',
  View: 'Ver',
  SynchronizeVideos: 'Sincronizar vídeos',
  Synchronize: 'Sincronizar',
  ErrorCreatingVideo: 'Ocorreu um erro ao criar o vídeo. Por favor, verifique as informações inseridas e tente novamente.',
  ErrorEditingVideo: 'Ocorreu um erro ao editar o vídeo. Por favor, verifique as informações inseridas e tente novamente.',
  Duration: 'Duração',
  SelectOrInviteUser: 'Selecionar ou convidar usuário',
  SelectOrInviteUsers: 'Selecionar ou convidar usuários',
  CheckDB: 'Verificar banco de dados',
  ManageGlobalLicenses: 'Gerenciar licenças globais',
  ManageRoleAssignments: 'Gerenciar atribuições de função',
  ManageUnitSystems: 'Gerenciar sistemas de unidades',
  ShareDrillhole: 'Compartilhar furos de sondagem',
  SignOffSurveys: 'Assinar pesquisas',
  ViewSurveyData: 'Exibir dados de pesquisa',
  OrganizationLogs: 'Registros da organização',
  ExportOrganizationDBLogsModalTitle: 'Exportar log de verificação de bancos de dados da organização',
  Format: 'Formato',
  Restore: 'Restaurar',
  RestoreBackupConfirmMessage:
    'Pretende restaurar esta cópia de segurança? Quaisquer alterações efectuadas na organização após a criação da cópia de segurança serão perdidas',
  RestoreBackupSuccessMessage: 'O processo de restauração do backup foi iniciado. Quando terminar, enviaremos um e-mail para você.',
  Backups: 'Cópias de segurança',
  OrganizationBackups: 'Backups organizacionais',
  PreviousValue: 'Valor anterior',
  PreviousHierarchy: 'Hierarquia anterior',
  Source: 'Origem',
  SourceTitle: 'Origem do registro com data {0}, valor anterior "{1}" e hierarquia anterior "{2}"',
  ViewSource: 'Exibir origem',
  ScopeId: 'Id do contexto',
  CurrentParentId: 'Id do pai atual',
  PreviousParentId: 'Id do pai anterior',
  CurrentHierarchy: 'Hierarquia atual',
  ScopeLogType: 'Tipo de registro de contexto',
  Descendants: 'Descendentes',
  ViewDescendants: 'Exibir descendentes',
  DatabaseInconsistencyLogs: 'Registros de inconsistência do banco de dados',
  InconsistencyFixStartedMessage:
    'O processo de correção de inconsistências foi iniciado; uma vez concluído, o resultado será visível na página Registros da organização.',
  OrganizationIsLocked: 'Essa organização está bloqueada no momento porque está sendo usada em outro processo. Aguarde e tente novamente em breve.',
  Statistics: 'Estatísticas',
  Last24Hours: 'Últimas 24 horas',
  Last3Days: 'Últimos 3 dias',
  Last7Days: 'Últimos 7 dias',
  Last28Days: 'Últimos 28 dias',
  FilterByDate: 'Filtrar por data',
  Projects: 'Projetos',
  Surveys: 'Pesquisas',
  ProjectsNumber: 'Número de projetos',
  UsersNumber: 'Número de usuários',
  SurveysNumber: 'Número de pesquisas',
  CreationDate: 'Data de criação',
  LastUpdate: 'Última atualização',
  CustomDateRange: 'Intervalo de datas personalizado',
  ErrorUpdatingRole: 'Ocorreu um erro ao atualizar as permissões da função. Por favor, tente novamente.',

  WorkingHours: 'Horas de trabalho',
  PleaseEnterWorkingHours: 'Por favor, insira as horas de trabalho',

  Weekly: 'Semanal',
  Monthly: 'Mensal',
  Quarterly: 'Trimestral',
  SharingDataSettings: 'Definições de dados de partilha',
  EmailAddresses: 'Endereços de email',
  EmailFrequency: 'Frequência de emails',

  Country: 'País',
  PleaseSelectCountry: 'Por favor, selecione um país',

  // Country names
  Afghanistan: 'Afeganistão',
  Albania: 'Albânia',
  Algeria: 'Argélia',
  Andorra: 'Andorra',
  Angola: 'Angola',
  'Antigua and Barbuda': 'Antígua e Barbuda',
  Argentina: 'Argentina',
  Armenia: 'Arménia',
  Australia: 'Austrália',
  Austria: 'Áustria',
  Azerbaijan: 'Azerbaijão',
  Bahamas: 'Bahamas',
  Bahrain: 'Bahrein',
  Bangladesh: 'Bangladesh',
  Barbados: 'Barbados',
  Belarus: 'Bielorrússia',
  Belgium: 'Bélgica',
  Belize: 'Belize',
  Benin: 'Benim',
  Bhutan: 'Butão',
  Bolivia: 'Bolívia',
  'Bosnia and Herzegovina': 'Bósnia e Herzegovina',
  Botswana: 'Botswana',
  Brazil: 'Brasil',
  Brunei: 'Brunei',
  Bulgaria: 'Bulgária',
  'Burkina Faso': 'Burkina Faso',
  Burundi: 'Burundi',
  Cambodia: 'Camboja',
  Cameroon: 'Camarões',
  Canada: 'Canadá',
  'Cape Verde': 'Cabo Verde',
  'Central African Republic': 'República Centro-Africana',
  Chad: 'Chade',
  Chile: 'Chile',
  China: 'China',
  Colombia: 'Colômbia',
  Comoros: 'Comores',
  'Costa Rica': 'Costa Rica',
  'Côte d’Ivoire': 'Costa do Marfim',
  Croatia: 'Croácia',
  Cuba: 'Cuba',
  Cyprus: 'Chipre',
  'Czech Republic': 'República Checa',
  'Democratic Republic of the Congo': 'República Democrática do Congo',
  Denmark: 'Dinamarca',
  Djibouti: 'Djibouti',
  Dominica: 'Dominica',
  'Dominican Republic': 'República Dominicana',
  'East Timor': 'Timor-Leste',
  Ecuador: 'Equador',
  Egypt: 'Egito',
  'El Salvador': 'El Salvador',
  'Equatorial Guinea': 'Guiné Equatorial',
  Eritrea: 'Eritreia',
  Estonia: 'Estónia',
  Ethiopia: 'Etiópia',
  Fiji: 'Fiji',
  Finland: 'Finlândia',
  France: 'França',
  Gabon: 'Gabão',
  Gambia: 'Gâmbia',
  Georgia: 'Geórgia',
  Germany: 'Alemanha',
  Ghana: 'Gana',
  Greece: 'Grécia',
  Grenada: 'Granada',
  Guatemala: 'Guatemala',
  Guinea: 'Guiné',
  'Guinea-Bissau': 'Guiné-Bissau',
  Guyana: 'Guiana',
  Haiti: 'Haiti',
  Honduras: 'Honduras',
  Hungary: 'Hungria',
  Iceland: 'Islândia',
  India: 'Índia',
  Indonesia: 'Indonésia',
  Iran: 'Irã',
  Iraq: 'Iraque',
  Ireland: 'Irlanda',
  Israel: 'Israel',
  Italy: 'Itália',
  Jamaica: 'Jamaica',
  Japan: 'Japão',
  Jordan: 'Jordânia',
  Kazakhstan: 'Cazaquistão',
  Kenya: 'Quénia',
  Kiribati: 'Kiribati',
  Kuwait: 'Kuwait',
  Kyrgyzstan: 'Quirguistão',
  Laos: 'Laos',
  Latvia: 'Letónia',
  Lebanon: 'Líbano',
  Lesotho: 'Lesoto',
  Liberia: 'Libéria',
  Libya: 'Líbia',
  Liechtenstein: 'Liechtenstein',
  Lithuania: 'Lituânia',
  Luxembourg: 'Luxemburgo',
  Madagascar: 'Madagáscar',
  Malawi: 'Malawi',
  Malaysia: 'Malásia',
  Maldives: 'Maldivas',
  Mali: 'Mali',
  Malta: 'Malta',
  'Marshall Islands': 'Ilhas Marshall',
  Mauritania: 'Mauritânia',
  Mauritius: 'Maurícia',
  Mexico: 'México',
  Micronesia: 'Micronésia',
  Moldova: 'Moldávia',
  Monaco: 'Mónaco',
  Mongolia: 'Mongólia',
  Montenegro: 'Montenegro',
  Morocco: 'Marrocos',
  Mozambique: 'Moçambique',
  Myanmar: 'Myanmar',
  Namibia: 'Namíbia',
  Nauru: 'Nauru',
  Nepal: 'Nepal',
  Netherlands: 'Países Baixos',
  'New Zealand': 'Nova Zelândia',
  Nicaragua: 'Nicarágua',
  Niger: 'Níger',
  Nigeria: 'Nigéria',
  'North Korea': 'Coreia do Norte',
  Norway: 'Noruega',
  Oman: 'Omã',
  Pakistan: 'Paquistão',
  Palau: 'Palau',
  Panama: 'Panamá',
  'Papua New Guinea': 'Papua-Nova Guiné',
  Paraguay: 'Paraguai',
  Peru: 'Peru',
  Philippines: 'Filipinas',
  Poland: 'Polónia',
  Portugal: 'Portugal',
  Qatar: 'Catar',
  'Republic of the Congo': 'República do Congo',
  'Republic of Macedonia': 'República da Macedónia',
  Romania: 'Roménia',
  Russia: 'Rússia',
  Rwanda: 'Ruanda',
  'Saint Kitts and Nevis': 'São Cristóvão e Nevis',
  'Saint Lucia': 'Santa Lúcia',
  'Saint Vincent and the Grenadines': 'São Vicente e Granadinas',
  Samoa: 'Samoa',
  'San Marino': 'San Marino',
  'Sao Tome and Principe': 'São Tomé e Príncipe',
  'Saudi Arabia': 'Arábia Saudita',
  Senegal: 'Senegal',
  Serbia: 'Sérvia',
  Seychelles: 'Seychelles',
  'Sierra Leone': 'Serra Leoa',
  Singapore: 'Singapura',
  Slovakia: 'Eslováquia',
  Slovenia: 'Eslovénia',
  'Solomon Islands': 'Ilhas Salomão',
  Somalia: 'Somália',
  'South Africa': 'África do Sul',
  'South Korea': 'Coreia do Sul',
  'South Sudan': 'Sudão do Sul',
  Spain: 'Espanha',
  'Sri Lanka': 'Sri Lanka',
  Sudan: 'Sudão',
  Suriname: 'Suriname',
  Swaziland: 'Suazilândia',
  Sweden: 'Suécia',
  Switzerland: 'Suíça',
  Syria: 'Síria',
  Tajikistan: 'Tajiquistão',
  Tanzania: 'Tanzânia',
  Thailand: 'Tailândia',
  Togo: 'Togo',
  Tonga: 'Tonga',
  'Trinidad and Tobago': 'Trinidad e Tobago',
  Tunisia: 'Tunísia',
  Turkey: 'Turquia',
  Turkmenistan: 'Turquemenistão',
  Tuvalu: 'Tuvalu',
  Uganda: 'Uganda',
  Ukraine: 'Ucrânia',
  'United Arab Emirates': 'Emirados Árabes Unidos',
  'United Kingdom': 'Reino Unido',
  'United States of America': 'Estados Unidos',
  Uruguay: 'Uruguai',
  Uzbekistan: 'Uzbequistão',
  Vanuatu: 'Vanuatu',
  Venezuela: 'Venezuela',
  Vietnam: 'Vietname',
  Yemen: 'Iémen',
  Zambia: 'Zâmbia',
  Zimbabwe: 'Zimbabwe',

  TestOrganization: 'Organização de teste',
  RemovalDate: 'Data de remoção',
  IsTestOrganization: 'É uma organização de teste',
  TestingEndDate: 'Data de término do teste:',
  TestOrgConfirmationMessage:
    'A entidade foi estabelecida como uma organização de teste e será automaticamente excluída na data selecionada. Tem certeza de que deseja continuar?',

  Show: 'Mostrar',
  Changed: 'Alterado',
  Unchanged: 'Inalterado',

  Charts: 'Gráficos',

  CreationChartLegend: 'Criação',
  UpdateChartLegend: 'Atualização',

  Confirm: 'Confirmar',

  SelectOrInviteWarning: 'Por favor selecione ou convide',
  InvalidEmailWarning: 'Por favor selecione ou digite um e-mail válido',

  UserHasNoOrganizationsWarning:
    'Este usuário não faz parte de nenhuma organização. Por favor, adicione-o a uma organização antes de atribuir funções.',

  UserHasNoOrganizationsGroupWarning:
    'Este usuário não faz parte de nenhuma organização. Por favor, adicione-o a uma organização antes de adicioná-lo a grupos.',

  'Customer Geologist': 'Geólogo do cliente',
  'Drillhole Manager': 'Gerente de furos',
  'Field Operator': 'Operador de campo',
  Geologist: 'Geólogo',
  'Global License Manager': 'Gerente de licenças globais',
  'License Manager': 'Gerente de licenças',
  'Organization Coordinator': 'Coordenador da organização',
  'Organization Master': 'Mestre da organização',
  'Partner Administrator': 'Administrador de parceiros',
  'Project Manager': 'Gerente de projeto',
  'Project Viewer': 'Visualizador de projetos',
  'Ring Manager': 'Gerente de rings',
  ViewAllOrganizations: 'Ver todas as organizações',
  'Organizations Viewer': 'Visualizador de organizações',

  GlobalLicenseAlreadyExists:
    'Você está tentando criar uma nova licença global para {0} #{1} de {6} até {7}, mas já existe uma licença global criada para {0} #{1} de {2} até {3} por {4} em {5}. Deseja continuar e criar uma nova licença mesmo assim?',
  UnlimitedGlobalLicenseAlreadyExists:
    'Já existe uma licença global ilimitada criada para {0} #{1} por {2} em {3}. Deseja continuar e criar uma nova licença mesmo assim?',
  Continue: 'Continuar',

  EditWarningGlobalLicenseAlreadyExists: 'Já existe uma licença global criada para {0} #{1} de {2} até {3} por {4} em {5}. Deseja continuar?',
  EditWarningUnlimitedGlobalLicenseAlreadyExists: 'Já existe uma licença global ilimitada criada para {0} #{1} por {2} em {3}. Deseja continuar?',
  EditWarningLicenseAlreadyExists: 'Já existe uma licença criada para {0} #{1} de {2} até {3} por {4} em {5} na organização {6}. Deseja continuar?',
  EditWarningUnlimitedLicenseAlreadyExists:
    'Já existe uma licença ilimitada criada para {0} #{1} por {2} em {3} na organização {4}. Deseja continuar?',

  UserLogin: 'Login do usuário',
  UserAccessOrganization: 'Acesso do usuário à organização',
  UserLogout: 'Logout do usuário',
  UserAddedToGroup: 'Usuário adicionado ao grupo',
  UserRemovedFromGroup: 'Usuário removido do grupo',
  RoleAssignedToUser: 'Função atribuída ao usuário',
  RoleUnassignedToUser: 'Função removida do usuário',
  RoleAssignedToGroup: 'Função atribuída ao grupo',
  RoleUnassignedToGroup: 'Função removida do grupo',
  InvitationAccepted: 'Convite aceito',
  BackupSuccess: 'Backup realizado com sucesso',
  BackupError: 'Erro no backup',
  RestoreBackupSuccess: 'Restauração do backup bem-sucedida',
  RestoreBackupError: 'Erro na restauração do backup',
  PleaseEnterStartAndEndDate: 'Por favor, insira a data de início e fim',

  ActiveHours: 'Horas ativa',
  Active: 'Ativo',
  NotActive: 'Não ativo',
  FilterByActiveDates: 'Filtrar por datas ativa',
  ActiveDays: 'Dias ativa',
  SelectedGroupAlreadyHasTheSelectedRoles: 'O grupo selecionado já possui os papéis: {0}.',

  Apply: 'Aplicar',

  FilterMode: 'Modo de filtro',
  AllSelected: 'Todos selecionados',
  AnyOfTheSelected: 'Qualquer um dos selecionados',
  Download: 'Baixar',

  ErrorCreatingLicense: 'Erro ao criar a licença',
  DeviceTypeNotAllowed: 'Tipo de dispositivo não permitido',

  RoleAssignmentAttributes: 'Atributos de atribuição de função',
  LicenseManagerRoleAttributes: 'Atributos da função de gerente de licenças',

  'StructMaster User': 'Usuário do StructMaster',
  UseStructMaster: 'Usar StructMaster',

  StructmasterLicenses: 'Licenças StructMaster',
  NewStructmasterLicenseAssignment: 'Nova atribuição de licença StructMaster',
  EditStructmasterLicenseAssignment: 'Editar atribuição de licença StructMaster',
  UserAlreadyHasStructMasterRole: 'Erro: Este usuário já possui o papel de StructMaster nesta organização',
  AddAnotherAssignment: 'Adicionar outra atribuição',
  AddRole: 'Adicionar papel',
  SelectRole: 'Selecionar papel',
  PleaseSelectRole: 'Por favor, selecione um papel',
  DuplicatedRolesWarning: 'Existem papéis duplicados na sua seleção. Certifique-se de que não há duplicatas.',
  RolesWillBeUpdated: 'Os seguintes papéis serão atualizados: {0}.',

  UserHasNoRoleWarning: 'O usuário deve ter pelo menos um papel na organização',

  UserWillBeAddedToOrganizationBeforeAssign:
    'Aviso: O usuário "{0}" não pertence à organização "{1}", portanto, o usuário "{0}" será adicionado à organização antes de fazer a atribuição.',

  ManageCategories: 'Gerenciar categorias',
  ManageGeographicInformationSystems: 'Gerenciar sistemas de informação geográfica',
  RoleExpirationDateChanged: 'Data de expiração do papel alterada',

  Appearance: 'Aparência',
  DarkTheme: 'Tema escuro',
  LightTheme: 'Tema claro',
  UseSystemTheme: 'Usar tema do sistema',
  MFAStatus: 'Status da autenticação multifator',
  Enabled: 'Ativado',
  Disabled: 'Desativado',
  EnableMFA: 'Ativar autenticação multifator',
  DisableMFA: 'Desativar autenticação multifator',

  UserLimit: 'Limite de usuários',
  PleaseEnterUserLimit: 'Por favor, insira o limite de usuários',
  CheckLicenseInfoAndUsersTabs: 'Por favor, verifique as abas de informações da licença e usuários. Algo está errado',
  LicenseInfo: 'Informações da licença',
  AddNewStructmasterLicense: 'Adicionar nova licença StructMaster',
  StructmasterLicense: 'Licença StructMaster',
  PleaseAddAtLeastOneUser: 'Por favor, adicione pelo menos um usuário',
  DuplicatedUserWarning: 'Este usuário já foi selecionado, por favor verifique',
  LicenseName: 'Nome da licença',
  UserAmountExceedLimit: 'O número de usuários inserido excede o limite selecionado, por favor verifique se os dados estão corretos.',

  UserAlreadyIsLicenseManagerError: 'Este usuário já pertence a um grupo de administradores de licenças. Por favor, selecione outro usuário',
  UserAlreadyIsStructmasterUserError: 'Este usuário já possui o papel de StructMaster. Por favor, selecione outro usuário',
  DefaultGroups: 'Grupos padrão',
  LicenseManagerGroups: 'Grupos de gerentes de licenças',
  UpdateAttributes: 'Atualizar atributos',
  ResetLicenseAccess: 'Redefinir acesso à licença',

  UserOnAddGroupAlreadyIsLicenseManagerError:
    'Este usuário já pertence a um grupo de administradores de licenças, e há pelo menos um grupo de administradores de licenças na sua seleção. Por favor, revise isso',
  MoreThanOneLicenseManagerGroupSelectedError:
    'Há mais de um grupo de administradores de licenças na sua seleção, e um usuário só pode pertencer a um único grupo de administradores de licenças. Por favor, revise sua seleção.',
  Default: 'Padrão',

  UnblockStructmasterLicense: 'Desbloquear licença do StructMaster',

  ThereIsAlreadyAStructmasterLicenseWithThisName: 'Já existe uma licença StructMaster com este nome, por favor selecione um nome diferente.',
  ThereIsAlreadyAGroupWithThisName: 'Já existe um grupo com este nome, por favor selecione um nome diferente',

  GroupLogsTableError: 'Ocorreu um erro ao carregar os registros de auditoria do grupo. Por favor, tente novamente.',
  DownloadQR: 'Baixar QR',

  SelectUsersToShare: 'Selecionar usuários para compartilhar',
  SelectOrEnterEmailAddress: 'Selecionar usuário ou inserir endereço de e-mail',
  Share: 'Compartilhar',
  NoUsersSelectedError: 'Por favor, selecione pelo menos um usuário ou insira um endereço de e-mail',
  AddEmail: 'Adicionar e-mail',
  FilterByUser: 'Filtrar por usuário',
  ApprovalPending: 'Aprovação Pendente',

  ActiveUser: 'Usuário ativo',

  AllowAllPermissionsForThisLevel: 'Permitir todas as permissões para este nível',
  AllowAllAvailablePermissions: 'Permitir todas as permissões disponíveis',
  AllowAllAvaliablePermissionsForThisSelector: 'Permitir todas as permissões disponíveis para este seletor',

  StructmasterLicensesOnlyOneActiveUserWarning: 'Aviso: Só pode haver um usuário ativo por vez para cada licença StructMaster.',

  OrganizationUserLimitWarningCreation: 'Aviso: Você só pode adicionar no máximo {0} usuários a uma organização',
  OrganizationUserLimitWarningParam:
    'Aviso: Você só pode adicionar no máximo {0} usuários a esta organização e já possui um total de {1}, então só poderá adicionar mais {2}.',
  OrganizationReachedUserLimit: 'Erro: Esta organização já atingiu o número máximo de usuários permitidos. Por favor, selecione outra organização.',
  NewGroupUserCountErrorParam:
    'Erro: Esta organização permite no máximo {0} usuários, com {1} atualmente, e você está tentando adicionar {2} novos. Verifique se as informações estão corretas.',
  TheFollowingUsersWillBeAddedToTheOrganization: 'Os seguintes usuários serão adicionados à organização:',

  UnsignedStructmasterLicenses: 'Licenças StructMaster não assinadas',
  SaveAndSignOff: 'Salvar e assinar',
  SignOffStructmasterLicenseWarningTitle: 'Assinar licença StructMaster',
  SignOffStructmasterLicenseWarningMessage:
    'Você está prestes a aprovar a criação de uma nova licença StructMaster. Os usuários serão adicionados à organização selecionada, caso ainda não façam parte dela, e o papel será atribuído. Deseja continuar?',

  ShowOnlyUnsignedLicenses: 'Mostrar apenas licenças pendentes de aprovação',
  ClearFilters: 'Limpar filtros',
  ApproveLicenses: 'Aprovar licenças',

  SoftwareVersion: 'Versão do software',
  DeleteUnsignedLicense: 'Excluir licença não aprovada',
  DeleteUnsignedLicenseWarning: 'Você tem certeza de que deseja excluir a licença não aprovada "{0}"?',
  ErrorUpdatingLicense: 'Erro ao atualizar a licença',
  DuplicatedRoleNameErrorCreate:
    'Erro ao criar o papel: Já existe um papel com o nome "{0}" na organização "{1}". Por favor, insira um nome diferente.',
  DuplicatedRoleNameErrorUpdate:
    'Erro ao atualizar o papel: Já existe um papel com o nome "{0}" na organização "{1}". Por favor, insira um nome diferente.',
  DuplicatedDefaultRoleNameErrorUpdate: 'Erro ao atualizar o papel: Já existe um papel padrão com o nome "{0}". Por favor, insira um nome diferente.',
  PleaseEnterAValidSearchTerm: 'Por favor, insira um termo de pesquisa válido',
  TextFieldLimitError: 'O campo "{0}" não deve exceder {1} caracteres',
  InvalidToolcode: 'Por favor, insira um código de ferramenta válido',
  LicenseManagerGroupsMustHaveAtLeastOneRole: 'Os grupos do gerenciador de licenças devem ter pelo menos uma função',
  PleaseSelectAtLeastOneDeviceType: 'Por favor selecione pelo menos um tipo de dispositivo',
  Language: 'Linguagem',

  UnsignedLicenseCreation: 'Criação de licença não assinada',
  SignedLicenseCreation: 'Criação de licença assinada',
  UnsignedLicenseUpdate: 'Atualização de licença não assinada',
  SignedLicenseUpdate: 'Atualização de licença assinada',
  ErrorCreatingUnsignedLicense: 'Erro ao criar licença não assinada',
  ErrorCreatingSignedLicense: 'Erro ao criar licença assinada',
  ErrorUpdatingUnsignedLicense: 'Erro ao atualizar licença não assinada',
  ErrorUpdatingSignedLicense: 'Erro ao atualizar licença assinada',
  DeleteSignedLicense: 'Excluir licença assinada',
  StructmasterLicenseLogs: 'Registros de licenças do StructMaster',
  PleaseEnterCoreDiameter: 'Por favor, insira o diâmetro do núcleo',
  CoreDiameter: 'Diâmetro do núcleo',

  AllowedGrantTypes: 'Tipos de concessão permitidos',
  Clients: 'Clientes',
  ClientsTableError: 'Ocorreu um erro ao carregar os clientes. Por favor, tente novamente.',
  AllowedScopes: 'Escopos permitidos',
  Implicit: 'Implícito',
  Hybrid: 'Híbrido',
  AuthorizationCode: 'Código de autorização',
  ClientCredentials: 'Credenciais do cliente',
  ResourceOwnerPassword: 'Senha do proprietário do recurso',
  DeviceFlow: 'Fluxo de dispositivo',
  Profile: 'Perfil',
  Phone: 'Telefone',
  OfflineAccess: 'Acesso offline',
  RedirectUris: 'URIs de redirecionamento',
  PostLogoutRedirectUris: 'URIs de redirecionamento após logout',
  AccessTokenType: 'Tipo de token de acesso',
  RefreshTokenUsage: 'Uso do token de atualização',
  AccessTokenLifetime: 'Tempo de vida do token de acesso',
  AbsoluteRefreshTokenLifetime: 'Tempo de vida absoluto do token de atualização',
  AllowAccessTokensViaBrowser: 'Permitir tokens de acesso via navegador',
  AllowOfflineAccess: 'Permitir acesso offline',
  AlwaysIncludeUserClaimsInIdToken: 'Sempre incluir reivindicações do usuário no Id Token',
  RequirePkce: 'Exigir PKCE',
  RequireConsent: 'Exigir consentimento',
  RequireClientSecret: 'Exigir segredo do cliente',
  ClientID: 'ID do cliente',
  ClientName: 'Nome do cliente',
  ProtocolType: 'Tipo de protocolo',
  NewClient: 'Novo cliente',
  EditClient: 'Editar cliente',
  General: 'Geral',
  ClientSecrets: 'Segredos do cliente',
  PleaseEnterAClientId: 'Por favor, insira um ID do cliente',
  PleaseEnterAClientName: 'Por favor, insira um nome do cliente',
  ReUse: 'Reutilizar',
  OneTimeOnly: 'Apenas uma vez',
  PleaseSelectTheAllowedScopes: 'Por favor, selecione os escopos permitidos',
  AddRedirectUri: 'Adicionar URI de redirecionamento',
  AddPostLogoutRedirectUri: 'Adicionar URI de redirecionamento após logout',
  PleaseEnterRedirectURI: 'Por favor, insira um URI de redirecionamento',
  PleaseEnterPostLogoutRedirectURI: 'Por favor, insira um URI de redirecionamento após logout',
  Value: 'Valor',
  PleaseEnterSecretValue: 'Por favor, insira o valor do segredo',
  PleaseEnterSecretDescription: 'Por favor, insira a descrição do segredo',
  AddClientSecret: 'Adicionar segredo do cliente',
  NoRedirectUriWarning: 'Por favor, adicione pelo menos um URI de redirecionamento na aba "URIs de redirecionamento"',
  NoPostLogoutRedirectUriWarning: 'Por favor, adicione pelo menos um URI de redirecionamento após logout na aba "URIs de redirecionamento"',
  NoSecretsWarning: 'Se "Exigir segredo do cliente" estiver marcado, você deve adicionar pelo menos um segredo na aba "Segredos do cliente"',
  PleaseSelectTheAllowedGrantTypes: 'Por favor, selecione os tipos de concessão permitidos',
  RedirectURIMustNotBeEmpty: 'O valor do URI de redirecionamento não deve estar vazio',
  PostLogoutRedirectURIMustNotBeEmpty: 'O valor do URI de redirecionamento após logout não deve estar vazio',
  SecretValueMustNotBeEmpty: 'O valor do segredo não deve estar vazio',
  SecretDescriptionMustNotBeEmpty: 'A descrição do segredo não deve estar vazia',
  AllDataEnterdIsCorrect: 'Todos os dados inseridos estão corretos',
  NoChangesMadeWarning: 'Não há alterações para salvar. Atualize qualquer campo para continuar.',
  ConfirmEditSecretValueTitle: 'Confirmar edição do valor secreto',
  ConfirmEditSecretValueMessage:
    'Tem certeza de que deseja editar o valor do segredo com a descrição "{0}"? Se continuar, o valor secreto anterior será perdido.',
  ManageClients: 'Gerenciar clientes',
  Usage: 'Uso',

  GlobalSmartCoreLicenseAlreadyExists:
    'Você está tentando criar uma nova licença global para {0} #{1} de {6} a {7} com diâmetro de ferramenta "{8}", mas já existe uma licença global criada para {0} #{1} com diâmetro de ferramenta "{8}" de {2} a {3} por {4} em {5}. Deseja continuar e criar uma nova licença mesmo assim?',
  UnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Já existe uma licença global ilimitada criada para {0} #{1} com diâmetro de ferramenta "{4}" por {2} em {3}. Deseja continuar e criar uma nova licença mesmo assim?',
  EditWarningGlobalSmartCoreLicenseAlreadyExists:
    'Já existe uma licença global criada para {0} #{1} com diâmetro de ferramenta "{7}" de {2} a {3} por {4} em {5}. Deseja continuar?',
  EditWarningUnlimitedGlobalSmartCoreLicenseAlreadyExists:
    'Já existe uma licença global ilimitada criada para {0} #{1} com diâmetro de ferramenta "{5}" por {2} em {3}. Deseja continuar?',
  ToolDiameter: 'Diâmetro da ferramenta',
  ToolcodeTooLarge: 'O código da ferramenta é demasiado grande. O código deve ser um número entre 1 e 65535',
  NotAllChildrenAreTestOrganizations:
    'Esta organização não pode ser definida como uma organização de teste porque pelo menos uma de suas organizações filhas não é de teste',
  'License Reviewer': 'Revisor de licenças',
  'Client Manager': 'Gerente de clientes',
  MeasurementCount: 'Pesquisas',
  ToolSerialNumber: 'Número de série da ferramenta',
  ExportCsvReport: 'Exportar relatório CSV',
  ToolType: 'Tipo de ferramenta',
  FirstUsedOn: 'Data do primeiro uso',
  LastUsedOn: 'Data do último uso',
  ErrorGeneratingReport: 'Ocorreu um erro ao gerar o relatório. Por favor, tente novamente.',
  ToolUsageReport: 'Relatório de uso de ferramentas',
  ExportToolUsageReport: 'Exportar relatório de uso de ferramentas',
  ToolUsageReportInProcess: 'O relatório de uso da ferramenta está sendo gerado. Ele será enviado para o seu e-mail quando estiver concluído.',
  ProjectName: 'Nome do Projeto',
  ManagePartnerOrganization: 'Gerenciar organização parceira',
  ManageAdminOrganization: 'Gerenciar organização administradora',
};
